import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { StandortModel } from "../../types/StandortModel";

@Injectable({
    providedIn: 'root'
})
export class StandortService extends RestServiceBase<StandortModel> {
    constructor(
    ) {
        super("StandortModel", false);
    }
}